'use strict';

/**
 * Communication handler implementation for Atex Metadata. Will request
 * metadata information from the given service end-point and parse the
 * result as JSON objects.
 */
(function($) {
  window.atex = window.atex || {};

  atex.MetadataAPIHandler = function(q, metadataUrl) {
    var serviceUrl = metadataUrl, formatJson = '?format=json';


    var createError = function(errorObject, jqXHR) {
      var error = atex.onecms.error.Error(_.extend(errorObject, { origin: 'atex.MetadataAPIHandler' }));

      if (jqXHR) {
        if (!_.isUndefined(jqXHR.status)) {
          error.rootCause.status = jqXHR.status;
        }

        if (!_.isUndefined(jqXHR.responseText) && jqXHR.responseText !== '') {
          try {
            error.rootCause.response = JSON.parse(jqXHR.responseText);
          } catch(parseError) {
            error.rootCause.response = jqXHR.responseText;
          }
        }
      }

      return error;
    };

    var handleHTTPError = function(jqXHR, deferred, messages) {
      var e = null;

      switch (jqXHR.status) {
        case 401:
          e = createError({
            type: atex.onecms.error.types.AUTHENTICATION_FAILED,
            cause: messages.authentication
          }, jqXHR);
          break;

        default:
          e = createError({
            type: atex.onecms.error.types.SERVER_ERROR,
            cause: messages['default']
          }, jqXHR);
          break;
      }

      deferred.reject(e);
    };

    return {
      getTaxonomy: function(taxonomyId, authToken) {
        var deferred = q.defer();

        var fullUrl = serviceUrl + '/structure/' + taxonomyId + formatJson;

        $.ajax(fullUrl, {
          dataType: 'json',
          beforeSend: function(jqXHR, settings) {
            jqXHR.setRequestHeader("X-Auth-Token", authToken);
          },
          success: function(data, textStatus, jqXHR) {
            deferred.resolve(data);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            handleHTTPError(jqXHR, deferred, {
              'authentication': 'While retrieving taxonomy from the server: user was not correctly authenticated!',
              'permission': 'While retrieving taxonomy from the server: permission denied!',
              'default': 'Error while retrieving taxonomy from the Metadata API!'
            });
          }
        });

        return deferred.promise;
      },

      annotate: function(taxonomyId, text, authToken) {
        var deferred = q.defer();

        var fullUrl = serviceUrl + '/annotation/' + taxonomyId + formatJson + "+allTypes";

        $.ajax(fullUrl, {
          type: 'POST',
          dataType: 'json',
          contentType: 'text/plain',
          data: text,
          beforeSend: function(jqXHR, settings) {
            jqXHR.setRequestHeader("X-Auth-Token", authToken);
          },
          success: function(json, textStatus, jqXHR) {
            deferred.resolve(json);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            handleHTTPError(jqXHR, deferred, {
              'authentication': 'While requesting suggested annotation from server: user was not correctly authenticated!',
              'permission': 'While requesting suggested annotation from server: permission denied!',
              'default': 'Error while requesting annotate from the Metadata API!'
            });
          }
        });

        return deferred.promise;
      }
    };
  };
})(jQuery);
